/**
 * Stripped-down header for maintenance takeover screens.
 * No navigation, no notifications badge, no API-fetching badges.
 * Just the brand logo to maintain a touchstone that the app is still "there".
 *
 * Mirrors the layout primitives of src/components/Header.tsx but trimmed.
 */
export function MaintenanceHeader() {
  return (
    <header
      className="flex w-full items-center justify-center pb-0 px-3.5"
      style={{ height: 'var(--header-content-height)' }}
    >
      <img
        // Fluid width per memory feedback_fluid_visual_harmony.md: the brand
        // wants visual harmony across all mobile widths (320-430px+). A
        // hard-coded 320px would touch edge-to-edge on iPhone SE (320px) and
        // potentially clip after safe-area inset. `w-full max-w-[320px]`
        // keeps the cap on larger screens while shrinking gracefully on
        // narrow ones.
        className="relative w-full max-w-[320px] h-16"
        alt="Meetball Logo"
        src="/Meetball Logo.svg"
        fetchPriority="high"
      />
    </header>
  );
}
